import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verify-personel-page',
  templateUrl: './verify-personel-page.component.html',
  styleUrls: ['./verify-personel-page.component.css']
})
export class VerifyPersonelPageComponent implements OnInit {
  title="Employee Information";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/Main/verify-personel-page/verify-personel-page.component.ts